import { ChannelFormFields } from './ChannelFormFields';
import { useAddChannelDialog } from './useAddChannelDialog';

export function ChannelForm() {
  const { formData, updateFormData } = useAddChannelDialog();

  return (
    <ChannelFormFields formData={formData} updateFormData={updateFormData} />
  );
}
